
import { Component } from "vue-property-decorator";
import { HcPageModel } from "@dev/hc-components";

@Component
export default class MainList extends HcPageModel {
    public name: string = "main-list";
    protected pageName: string = "mainList";

    private get pathOrigin(): string {
        return window.location.origin;
    }

    private substituteOrigin(key: string): string {
        return this.$localize(key, this.pathOrigin);
    }

    private get redirectToMyloanExample1(): string {
        return this.substituteOrigin("doc-modal-redirectToMyloan-example1");
    }

    private get redirectToMyloanExample2(): string {
        return this.substituteOrigin("doc-modal-redirectToMyloan-example2");
    }

    private get myloanRedirectUrlExample(): string {
        return this.substituteOrigin("doc-modal-myloanRedirectUrl-example");
    }
}
